import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/app/[locale]/(jupiter-frame)/page.tsx");
